import { createRouter, createWebHistory,createWebHashHistory} from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Index',
    meta:{index:1},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/index.vue'),
  },
  {
    path: '/work',
    name: 'Work',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/work.vue'),
  },
  {
    path: '/internship',
    name: 'Internship',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/internship.vue'),
  },
  {
    path: '/setup',
    name: 'Setup',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/setup.vue'),
  },
  {
    path: '/bill',
    name: 'Bill',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/bill.vue'),
  },
  {
    path: '/welTransfer',
    name: 'WelTransfer',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/welTransfer.vue'),
  },
  {
    path: '/jCtransfer',
    name: 'jCTransfer',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/jCtransfer.vue'),
  },
  {
    path: '/jCtransferrod',
    name: 'jCTransferrod',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/jCtransferrod.vue'),
  },
  {
    path: '/bank',
    name: 'Bank',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/bank.vue'),
  }, {
    path: '/team',
    name: 'Team',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/team.vue'),
  },
  {
    path: '/jhcard',
    name: 'Jhcard',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/jhcard.vue'),
  },
  {
    path: '/recharge',
    name: 'Recharge',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/recharge.vue'),
  },
  {
    path: '/tbuy',
    name: 'Tbuy',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/tbuy.vue'),
  },
  {
    path: '/czRod',
    name: 'CzRod',
    meta:{index:3},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/czRod.vue'),
  },{
    path: '/zzRod',
    name: 'ZzRod',
    meta:{index:3},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/zzRod.vue'),
  },{
    path:'/withdraw',
    name: 'Withdraw',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/withdraw.vue'),
  },{
    path: '/txRod',
    name: 'TxRod',
    meta:{index:3},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/txRod.vue'),
  },{
    path:'/exchange',
    name: 'Exchange',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/exchange.vue'),
  },{
    path:'/dhRod',
    name: 'DhRod',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/dhRod.vue'),
  },{
    path:'/transfer',
    name: 'Transfer',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/transfer.vue'),
  },
  {
    path:'/transferrod',
    name: 'Transferrod',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/transferrod.vue'),
  },
  {
    path:'/box',
    name: 'Box',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/box.vue'),
  },
  {
    path:'/boxDetail',
    name: 'BoxDetail',
    meta:{index:2},
    component: () => import(/* webpackChunkName: "home" */ './pages/index/boxDetail.vue'),
  }
]

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

// 0-9，a-z, length:8
const randomString = () => {
  return Math.random().toString(36).slice(-8)
}

router.beforeEach((to) => {
  
})

router.afterEach(() => {
  // 隐藏菜单
  // hideMenuItems()
})
